import axios from 'axios'
import { BINANCE_API_BASE_URL } from 'config'

export interface GetBinanceKLineParams {
  symbol: string
  interval: string
  startTime?: number
  endTime?: number
  limit?: number
  exchange?: string
}

export async function getBinanceKLine(params: GetBinanceKLineParams) {
  return axios.get(`/api/v1/kline/history`, {
    baseURL: BINANCE_API_BASE_URL,
    params: {
      symbol: params.symbol,
      interval: params.interval,
      startTime: params?.startTime,
      endTime: params?.endTime,
      limit: params?.limit,
      exchange: params?.exchange,
    },
  })
}
